import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import { DonorPicker } from './donorPicker';

type DonorAdvancedSearchSectionProps = {
  donorId?: number;
  onDonorChange?: (donorId: number | undefined, donorName: string | undefined) => void;
};

export const DonorAdvancedSearchSection = (props: DonorAdvancedSearchSectionProps) => {
  const { donorId, onDonorChange } = props;
  const { t } = useTranslation();

  return (
    <Box mt={1}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3}>
          <DonorPicker label={t('gift:recurringDonor')} initialValue={donorId} callback={(id, name) => onDonorChange?.(id, name)} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <ControlledTextField bgcolor='white' name='donorName' label={t('gift:donorName')} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <ControlledTextField bgcolor='white' name='donorEmail' label={t('gift:donorEmail')} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <ControlledTextField bgcolor='white' name='honoredName' label={t('gift:honoredName')} />
        </Grid>
      </Grid>
    </Box>
  );
};
